module.exports = __webpack_public_path__ + "img/7184a44.webp";